import React from 'react'

//Components
import Navbar from '../components/Global/Navbar.jsx'
import Banner from '../components/Banner.jsx'
import Searchbar from '../components/Searchbar.jsx'
import Featured from '../components/Feautured.jsx'
import Services from '../components/Services.jsx'
import Offers from '../components/Offers.jsx'
import Counter from '../components/Counter.jsx'
import Team from '../components/Team.jsx'
import Testimonial from '../components/Testimonial.jsx'
import Partners from '../components/Partners.jsx'
import Footer from '../components/Global/Footer.jsx'
import Nosotros from '../components/Nosotros'

const home = () => {
    return (
        <React.Fragment>
            <Navbar />
            <Banner />
            <Searchbar />
            <Featured />
            
            <Services />
            <Offers />
            <Nosotros/>
            <Counter />
            <Team />
            <Testimonial />
            <Partners />
            <Footer />
        </React.Fragment>
    )
}

export default home



// WEBPACK FOOTER //
// ./src/pages/home.jsx